<script>
import ListDefault from "../Utils/Page/ListDefault";

export default {
    name: "List",
    mixins: [ListDefault],
    data() {
        return {
            lang: this.$ml.get('pages.valuation'),

            filter: {
                title: { value: null, type: 'text'},
                user_id: { value: null, type: 'text'},
                status_id: { value: null, type: 'select', options: []},
            },

            tableHeader: [
                //{ label: '#', is_sort: false },
                { key: 'id', is_sort: true },
                { key: 'user_id', is_sort: true, classes: 'text-l' },
                { key: 'email', is_sort: true, classes: 'text-l' },
                { key: 'artifact_id', is_sort: true, classes: 'text-l' },
                { key: 'paid_appraisal', is_sort: true, classes: 'text-l' },
                { key: 'status_id', is_sort: true, classes: 'text-l' },
                { key: 'created_at', is_sort: true, classes: 'text-l' },
            ],

            tableBody: {
                'user_id': { type: 'function', function: this.getUser },
                'artifact_id': { type: 'function', function: this.getArtifact },
                'status_id': { type: 'function', function: this.getStatus },
                'paid_appraisal': { type: 'function', function: this.getPaymentAppraisal },
                'created_at': { type: 'function', function: this.getDate },
            },

            apiList: this.$store.getters.getApiUrl('valuation'),
            pageRoute: 'valuation',
            pageRouteCreate: 'valuation.create',
            pageRouteEdit: 'valuation.edit',
            pagePermission: 'artifact.valuation',
        }
    },
    mounted() {
        this.getDictionaries().then(({data}) => {
            this.dictionaries = data.dictionaries

            for (let key in this.filter) {
                if (this.dictionaries[key]) {
                    this.filter[key].options = this.dictionaries[key]
                }
            }
        })
    },
    methods: {
        getArtifact(item) {
            return `<a href="${item.artifact.url}" class="link" target="_blank">${item.artifact.title}</a>`
        },
        getUser(item) {
            return `@${item.user.name}`
        },
        getStatus(item) {
            return item.status ? item.status.title : null
        },
        getDate(item) {
            return item.created_at ? this.$func.getDateTime(item.created_at) : null
        },
        getPaymentAppraisal(item) {
            return item.paid_appraisal ? 'YES' : 'NO'
        },
    },
}
</script>

<style scoped>

</style>
